module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "id": "Layer_1",
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 60 60"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M57.42,24.38l-5.75-4.8a5.23,5.23,0,0,0-3.34-1.21H42.89v-.68a3.41,3.41,0,0,0-3.16-3.39l-2.35,0h0a1.37,1.37,0,0,0,0,2.74h2.16a.67.67,0,0,1,.64.67v21.2H32l-.18,0a5.47,5.47,0,0,0-4.18-4h0a1.12,1.12,0,0,0-.32,0,1.36,1.36,0,0,0-.36,2.68h0a2.73,2.73,0,0,1,2.29,2.69h0a2.74,2.74,0,0,1-4.37,2.19h0a1.34,1.34,0,0,0-.91-.35,1.36,1.36,0,0,0-1.37,1.36,1.38,1.38,0,0,0,.49,1h0c.07.06.14.1.21.15a5.43,5.43,0,0,0,8.51-3H44.43a5.46,5.46,0,0,0,10.58,0h.88a3.42,3.42,0,0,0,3.41-3.41V28.38A5.18,5.18,0,0,0,57.42,24.38ZM49.72,43A2.73,2.73,0,0,1,47,40.26h0a2.73,2.73,0,0,1,2.73-2.73h0a2.74,2.74,0,1,1,0,5.47Zm6.84-4.77a.67.67,0,0,1-.67.67H55a5.46,5.46,0,0,0-10.58,0H42.89V21.1h5.44a2.51,2.51,0,0,1,1.59.58l5.75,4.8a2.44,2.44,0,0,1,.89,1.9Z"
    }
  }), _c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "10.52",
      "y": "14.27",
      "width": "24.07",
      "height": "2.77",
      "rx": "1.39"
    }
  }), _c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "4.2",
      "y": "29.76",
      "width": "24.07",
      "height": "2.77",
      "rx": "1.39"
    }
  }), _c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "0.7",
      "y": "37.5",
      "width": "24.07",
      "height": "2.77",
      "rx": "1.39"
    }
  }), _c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "7.65",
      "y": "22.02",
      "width": "24.07",
      "height": "2.77",
      "rx": "1.39"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10601486"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/ExpeditedTwoIcon.vue
// module id = 677
// module chunks = 0